module.exports = __webpack_public_path__ + "img/excel.58b9752d.png";